import { TramOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    addDays,
    endOfMonth,
    format,
    getDay,
    isBefore,
    isSameDay,
    isToday,
    parseISO,
    startOfMonth,
    subDays,
} from 'date-fns';
import React from 'react';
import DayItemComponentEmpty from './DayItemComponentEmpty';
import DayItemComponentFull from './DayItemComponentFull';

const Item = styled(Box)(({ theme }) => ({
    color: theme.palette.white.main,
    p: 1,
    borderRadius: 1,
    fontSize: 19,
    fontWeight: '700',
    minHeight: '60px',
}));

const CreateDaysInMonth = props => {
    const selectedDate = props.dateObject;
    const monthStart = startOfMonth(selectedDate);
    const monthEnd = endOfMonth(selectedDate);
    const monthData = props.data;

    const dateFormat = 'd';
    const displayDateFormat = 'haaaaa';

    let days = [];
    let day = monthStart;
    let formattedDate = '';
    let foundFirstDay = false;
    let monthFinshed = false;
    let keyRef = 1;

    while (day < monthEnd) {
        //for (let i = 0; i < 7; i++) {
        const tempDay = day;
        formattedDate = format(day, dateFormat);

        const todaysAppt = monthData.filter(item => {
            var test = isSameDay(tempDay, parseISO(item.startDate));
            if (test) {
                return item;
            }
            return false;
        });

        //if ()
        const addDay = (key, formattedDate1, todaysAppt) => {
            // previous dates before today
            let previously = isBefore(day, subDays(Date.now(), 1));
            if (formattedDate1 === '') {
                //Building the grid where this day in the month doesn't exist
                return (
                    <Item key={key}>
                        <div></div>
                    </Item>
                );
            } else {
                if (todaysAppt.length > 0) {
                    return (
                        <DayItemComponentFull
                            key={key}
                            previous={previously}
                            isToday={isToday(day)}
                            direction="right"
                            todaysAppt={todaysAppt[0]}
                            type="edit"
                            formattedDate={formattedDate1}
                            displayDateFormat={displayDateFormat}
                            toggleDrawer={props.toggleDrawer}
                            disabled={props.disabled}
                        />
                    );
                } else {
                    return (
                        <DayItemComponentEmpty
                            key={key}
                            previous={previously}
                            isToday={isToday(day)}
                            direction="left"
                            tempDay={tempDay}
                            type="add"
                            formattedDate={formattedDate1}
                            displayDateFormat={displayDateFormat}
                            toggleDrawer={props.toggleDrawer}
                            disabled={props.disabled}
                        />
                    );
                }
            }
        };

        //before the calendar starts creating boxes with calendar days it needs to create blank boxes.
        //This code checks what day is the start day and loops through creating blank boxes then to indicate the next
        //box will be number 1 of that month it sets foundFirstDay to true
        if (isSameDay(monthStart, tempDay) && foundFirstDay === false) {
            for (var i = 0; i < getDay(monthStart); i++) {
                if (i === 0) {
                    days.push(addDay(40 + i, '', todaysAppt));
                } else {
                    days.push(addDay(40 + i, '', todaysAppt));
                }
            }
            foundFirstDay = true;
            //Once the first day is found, this code creates boxes with the right number. It needs to know if they are a weekend or not
            //if order to determine if it gets 2 sections on the 12 grid layout or only 1
        } else if (foundFirstDay === true && monthFinshed === false) {
            days.push(addDay(keyRef, formattedDate, todaysAppt));
            if (isSameDay(tempDay, monthEnd)) {
                monthFinshed = TramOutlined;
            }
            day = addDays(day, 1);
            keyRef = keyRef + 1;

            //This section creates empty boxes at the end of the month after the last day of the month
        } else {
            days.push(addDay(keyRef, '', todaysAppt));
            keyRef = keyRef + 1;
            day = addDays(day, 1);
        }
    }
    return (
        <Box
            sx={{
                display: 'grid',
                columnGap: 0.5,
                rowGap: 0.5,
                gridTemplateColumns: 'repeat(7, minmax(30px, 1fr))',
                padding: '10px 10px 0',
            }}
        >
            {days}
        </Box>
    );
};

export default CreateDaysInMonth;
